import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Stack, Text } from 'xen-ui';
import { DocumentListDelete } from './document-list-delete';
import { DocumentListDownload } from './document-list-download';
export const DocumentList = ({ documents }) => {
    return (_jsx(Stack, { gap: "xs", children: documents.map((document) => {
            return (_jsxs(Group, { align: "flex-start", gap: "0.1rem", wrap: "nowrap", children: [_jsx(DocumentListDownload, { document: document }), _jsx(DocumentListDelete, { document: document }), _jsx(Text, { "data-test-id": `document-item-${document.id}`, size: "sm", style: { wordBreak: 'break-all' }, children: document.documentName })] }, document.id));
        }) }));
};
